import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';

import GetPaginatedResponse from '../Responses/PaginatedResponse';

import MissingTranslationArticle from 'Api/Models/MissingTranslationArticle';

class MissingTranslationsApi extends AbstractCRMApi {
    public endpoint: string = 'missing-translations';

    public async getMissingTranslationsForArticles(
        partials: boolean,
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<MissingTranslationArticle>> {
        return this.get(`/${partials ? 'partials' : 'articles'}?page=${page}`, config).then(
            (response: AxiosResponse<GetPaginatedResponse>) => {
                return AbstractCRMApi.mapPaginatedDataToModel(response.data, MissingTranslationArticle);
            }
        );
    }
}

export default new MissingTranslationsApi();
